import { Route, Routes } from "react-router-dom";

import Products from "./Products";

function ProductRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Products />} />
    </Routes>
  );
}

export default ProductRoutes;
